import { makeRequestAction } from './index';

export const updateUserSettings = makeRequestAction('UPDATE_USER_SETTINGS', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});

export const getUserSettings = makeRequestAction('GET_USER_SETTINGS', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
